import { render, staticRenderFns } from "./DayOffEmployeeDialog.vue?vue&type=template&id=2a8551d8&scoped=true"
import script from "./DayOffEmployeeDialog.vue?vue&type=script&lang=js"
export * from "./DayOffEmployeeDialog.vue?vue&type=script&lang=js"
import style0 from "./DayOffEmployeeDialog.vue?vue&type=style&index=0&id=2a8551d8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8551d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a8551d8')) {
      api.createRecord('2a8551d8', component.options)
    } else {
      api.reload('2a8551d8', component.options)
    }
    module.hot.accept("./DayOffEmployeeDialog.vue?vue&type=template&id=2a8551d8&scoped=true", function () {
      api.rerender('2a8551d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/schoolconfig/DayOffEmployeeDialog.vue"
export default component.exports